module.exports = __webpack_public_path__ + "static/uconn.ec853428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/uconn.jpg
// module id = 2202
// module chunks = 61762850755587